import { render, staticRenderFns } from "./ProcedureTypeEdit.vue?vue&type=template&id=6b1a9446&"
import script from "./ProcedureTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ProcedureTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports